import React from 'react';
import { Block3dType } from '../../../types/block-3d-type';
import './Plate.scss';

interface IPlateProps {
  children?: React.ReactNode;
  plateType?: Block3dType | undefined;
  isElevated?: boolean;
  doNotCompensateBottom?: boolean;
  glow?: 1 | 2 | undefined;
  isSubplate?: boolean;
  isClickable?: boolean;
  handleMouseUp?: () => void;
}

export function Plate({ children, plateType, isElevated, doNotCompensateBottom, glow, isSubplate, isClickable, handleMouseUp }: IPlateProps) {
  const CSS_PLATE = 'Plate';
  
  const CSS_ELEVATED = `${CSS_PLATE}__elevate`;
  
  const CSS_COMPENSATE_BORDER = `${CSS_PLATE}__compensate-border`;
  const CSS_COMPENSATE_BORDER_WITHOUT_BOTTOM = `${CSS_PLATE}__compensate-border--without-bottom`;

  const CSS_GLOW = `${CSS_PLATE}__glow--${glow}`;

  const CSS_SUBPLATE = `${CSS_PLATE}__subplate`;

  const cssClass = `
    ${ CSS_PLATE } 
    ${ plateType ? plateType : 'neutral' } 
    ${ isElevated ? CSS_ELEVATED : '' } 
    ${ glow ? CSS_GLOW : '' } 
    ${ isSubplate ? CSS_SUBPLATE : '' }
    ${ isClickable ? `${CSS_PLATE}__clickable` : '' }
  `;
  return (
    <div className={ doNotCompensateBottom ? CSS_COMPENSATE_BORDER_WITHOUT_BOTTOM : CSS_COMPENSATE_BORDER }>
      <div className={ cssClass } onMouseUp={ isClickable ? handleMouseUp : undefined }>
        <div className="Plate__content">
          { children }
        </div>
      </div>
    </div>
  );
}
